import { ShieldCheck } from "lucide-react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { LEGAL_SECTIONS, COMPLIANCE_TEXT } from "@/components/fleet/legalContent";
import { EscrowSeal } from "@/components/fleet/EscrowSeal";

export const LegalSheet = ({ open, onClose, section, onSection }) => (
  <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
    <SheetContent data-testid="legal-sheet" className="ff-glass-panel w-full sm:max-w-lg overflow-y-auto">
      <SheetHeader className="text-left">
        <SheetTitle className="ff-display text-2xl font-extrabold text-white flex items-center gap-2"><ShieldCheck className="text-[#3B82F6]" size={24} /> Legal & Security</SheetTitle>
        <SheetDescription className="text-[#94A3B8]">Conformità B2B, GDPR ed Escrow.</SheetDescription>
      </SheetHeader>
      <p className="mt-6 rounded-xl border border-[#3B82F6]/50 bg-[#3B82F6]/10 p-4 text-sm text-white leading-relaxed">{COMPLIANCE_TEXT}</p>
      <div className="mt-3"><EscrowSeal testid="legal-escrow-seal" /></div>
      <Accordion type="single" collapsible value={section} onValueChange={onSection} className="mt-4">
        {LEGAL_SECTIONS.map((s) => (
          <AccordionItem key={s.id} value={s.id} className="border-[#27272A]">
            <AccordionTrigger data-testid={`legal-section-${s.id}`} className="text-left text-white font-semibold hover:no-underline py-5">{s.title}</AccordionTrigger>
            <AccordionContent className="text-[#94A3B8] text-sm leading-relaxed flex flex-col gap-2">
              {s.body.map((p) => <p key={p}>{p}</p>)}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <p className="mt-6 text-xs text-[#71717a]">Testi informativi da validare con il proprio consulente legale prima del lancio.</p>
    </SheetContent>
  </Sheet>
);
